/**
 * The fields Enbase's BuildAssetTagDTO emits when the tag dialog converts its edited tag back for
 * the grid. A field the user cleared comes back absent, because BuildAssetTagDTO deletes values
 * that are "" or NaN. Kept in step with enbase_common by a contract test.
 */
export const CONVERTED_TAG_FIELDS = [
  "Alarm2ArmingTimeLimit",
  "Alarm2ArmingTypeId",
  "Alarm2Deadband",
  "Alarm2DigitalOutputChannel",
  "Alarm2Id",
  "Alarm2IsEnabled",
  "Alarm2LimitRangeId",
  "Alarm2PriorityId",
  "Alarm2RateLimit",
  "Alarm2TimeLimit",
  "Alarm2TypeId",
  "AlarmArmingDelay",
  "AlarmArmingTypeId",
  "AlarmDeadband",
  "AlarmDigitalOutputChannel",
  "AlarmHi",
  "AlarmHiHi",
  "AlarmId",
  "AlarmLimitRangeId",
  "AlarmLo",
  "AlarmLoLo",
  "AlarmRateLimit",
  "AlarmSeverityId",
  "AlarmTimeLimit",
  "AlarmTypeId",
  "AssetId",
  "AssetTagId",
  "ChannelNumber",
  "CodeLegendId",
  "DataTypeId",
  "DefaultValue",
  "Description",
  "DeviceParams",
  "DisplayAsDetail",
  "DisplayFormat",
  "DisplayOrder",
  "DynamicProperties",
  "Gain",
  "GaugeTypeId",
  "GroupName",
  "HiBandNotificationPriorityId",
  "IsActive",
  "IsAlarmEnabled",
  "IsWriteable",
  "LoBandNotificationPriorityId",
  "LoggingFrequency",
  "MaxValue",
  "MinValue",
  "Offset",
  "ParentAssetTagId",
  "ParentTagIdentifier",
  "PerformScalingOnServer",
  "PortNumber",
  "Property",
  "ScanFrequency",
  "ServerGain",
  "ServerOffset",
  "ShortDisplayName",
  "ShortUnitOfMeasure",
  "SourceName",
  "SparseData",
  "StrappingTableId",
  "SyncToHub",
  "TagIdentifier",
  "TagName",
  "TagSourceTypeId",
  "TagTypeId",
  "Transform",
  "UnitOfMeasure",
  "UniversalDescriptor",
];

/** Identity fields the dialog copies back from the source tag itself. */
const RESTORED_IDENTITY_FIELDS = ["TagId", "TCTagLayerId", "AssetNumber"];

/**
 * Lookup names, and the legacy SourceTypeId alias, that follow IDs the dialog edits. A value kept
 * from the source tag could contradict the edited ID.
 */
const FIELDS_DERIVED_FROM_EDITED_IDS = [
  "SourceType",
  "SourceTypeId",
  "AlarmType",
  "Alarm2Type",
  "AlarmSeverity",
  "AlarmLimitRange",
  "Alarm2LimitRange",
  "AlarmArmingType",
  "Alarm2ArmingType",
  "DataType",
  "TagType",
];

/** Transient fields that must not outlive a dialog save: the grid re-adds `index` every render. */
const NEVER_CARRIED_OVER = ["id", "index"];

const fieldsNotKeptFromSource = new Set([
  ...CONVERTED_TAG_FIELDS,
  ...RESTORED_IDENTITY_FIELDS,
  ...FIELDS_DERIVED_FROM_EDITED_IDS,
  ...NEVER_CARRIED_OVER,
]);

/**
 * The tag a dialog save produces: the dialog's result, plus every field of the source tag that the
 * dialog does not represent (e.g. TagListName, OutOfRange*), which its conversion would otherwise
 * drop.
 * @param {object} sourceTag The grid tag the dialog was opened for.
 * @param {object} dialogTag The dialog's converted result.
 * @returns {object}
 */
export const applyDialogResult = (sourceTag, dialogTag) => ({
  ...Object.fromEntries(
    Object.entries(sourceTag).filter(
      ([field]) => !fieldsNotKeptFromSource.has(field)
    )
  ),
  ...dialogTag,
});
